import { Collection } from "@type-r/models";
import React from "react";
import { UnresolvedGroupInfo } from "../common";
import { PaymentOpenItems } from "../../common/open-items";

export const PendingUnresolvedRas = ({ras}:{ras : Collection<UnresolvedGroupInfo>}) => {

    const unresolvedRasTotalCount = ras.reduce((curr:number, sum) => curr + sum.count, 0)

    return (<PaymentOpenItems title={`Open Items - (${unresolvedRasTotalCount})`}
                    payments={ras}
                    linkUrl='inmatch/remittance-advices/unresolved'
                    type='unresolved-ras'/>
    );
}
